<template>
    <div class="page-tabs-wrap">
        <div class="tab-item" v-for="(item,index) in tabsList" :key="index"
             :class="{active: currIndex === index}" @click="setTab(index)">
            <a href="javascript:;" class="tab-link-item">
                {{item.label}} {{total[index]?total[index] :''}}
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'kzptabs',
    props: {
      tabsList: {
        type: Array,
        default () {
          return []
        }
      },
      total: {
        type: Array,
        default () {
          return []
        }
      },
      tabsIndex: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        index: 0,
        grid: {items: [], total: 0},
      }
    },
    computed: {
      currIndex () {
        return this.tabsIndex || this.index
      }
    },
    methods: {
      setTab (index) {
        if (index >= 0 && index < this.tabsList.length) {
          this.index = index
          const item = Object.assign(this.tabsList[index], {index: index})
          this.$emit('changtab', item)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .page-tabs-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 25px;

        .tab-item {
            padding: 5px 32px;
            margin: 0 10px;

            &.active {
                background: rgba(28, 142, 255, 1);
                border: 1px solid rgba(21, 138, 255, 1);
                border-radius: 10px;
            }
        }

        .tab-link-item {
            color: #282828;
            text-decoration: none;
            font-size: 14px !important;
        }

        .active .tab-link-item {
            color: #fff;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/KzpTabs.vue